<template>
  <div class="container">
    <div class="alert alert-success alert-container">
      <p class="text-center">
        {{ `${strings.orderSuccess.msg1_} ${savedOrder ? savedOrder._id : ''}  ${strings.orderSuccess.msg2_} ${savedOrder ? savedOrder.email : ''} ${strings.orderSuccess.msg3_}` }}
      </p>
    </div>
    <h3 class="text-center sentence">
      Keep pushin' on finding your own SPLENDOR!
    </h3>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'OrderSuccess',
  data () {
    return {
      savedOrder: null
    }
  },
  computed: {
    ...mapGetters([
      'order', 'strings'
    ]),
    ...mapActions(['removeOrder'])
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      this.savedOrder = this.order
      if (!this.savedOrder) this.$router.push({ name: 'Shop' })
      await this.removeOrder
    }
  }
}
</script>

<style scoped lang="scss">
.alert-container {
  margin-top: 200px;
}
.sentence {
  margin-top: 150px;
}
</style>
